import { Switch } from '@/components/ui/switch';

interface ToggleFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  addonPrice?: number;
  disabled?: boolean;
  forcedValue?: string | null;
  error?: string;
}

export function ToggleField({
  label,
  value,
  onChange,
  addonPrice,
  disabled = false,
  forcedValue,
  error,
}: ToggleFieldProps) {
  const isForced = forcedValue !== null && forcedValue !== undefined;
  const displayValue = isForced ? forcedValue : value;
  const isChecked = displayValue === '1' || displayValue === 'true' || displayValue === 'Yes';

  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <label className="text-sm font-medium text-foreground">{label}</label>
          {addonPrice != null && addonPrice > 0 && (
            <span className="rounded-full bg-sky-50 px-2 py-0.5 text-xs font-medium text-sky-700 dark:bg-sky-950 dark:text-sky-300">
              +฿{addonPrice.toLocaleString()}
            </span>
          )}
        </div>
        <Switch
          checked={isChecked}
          onCheckedChange={(checked) => {
            if (!isForced) onChange(checked ? '1' : '0');
          }}
          disabled={disabled || isForced}
        />
      </div>
      {error && <p className="text-xs text-red-500">{error}</p>}
    </div>
  );
}
